(function() {
  var toc = document.querySelector('[data-article-toc]');
  if (!toc) return;

  var article = document.querySelector('.sc-article');
  var header = document.querySelector('.site-header');
  var announcement = document.querySelector('.announcement');
  var items = toc.querySelectorAll('.sc-article__toc-item');
  var links = toc.querySelectorAll('a[href^="#"]');
  var offset = 120;
  var locked = false;
  var unlockTimer = 0;
  var ticking = false;

  function measureOffset() {
    var chrome = 0;
    if (header) {
      chrome = header.offsetHeight;
      if (announcement) {
        var paddingTop = parseFloat(window.getComputedStyle(header).paddingTop) || 0;
        if (paddingTop < announcement.offsetHeight / 2) {
          chrome += announcement.offsetHeight;
        }
      }
    } else if (announcement) {
      chrome = announcement.offsetHeight;
    }
    offset = Math.round(chrome) + 16;
    if (article) article.style.setProperty('--sc-article-anchor-offset', offset + 'px');
  }

  function setActive(hash) {
    for (var i = 0; i < items.length; i++) {
      var link = items[i].querySelector('a');
      var on = link && link.getAttribute('href') === hash;
      items[i].classList.toggle('is-active', on);
      if (!link) continue;
      if (on) {
        link.setAttribute('aria-current', 'location');
      } else {
        link.removeAttribute('aria-current');
      }
    }
  }

  function syncActive() {
    var current = links.length ? links[0].getAttribute('href') : '';
    var closest = Infinity;
    for (var i = 0; i < links.length; i++) {
      var id = links[i].getAttribute('href').slice(1);
      var target = document.getElementById(id);
      if (!target) continue;
      var fromLine = target.getBoundingClientRect().top - offset;
      var distance = Math.abs(fromLine);
      if (fromLine <= 24 && distance <= closest) {
        closest = distance;
        current = '#' + id;
      }
    }
    if (current) setActive(current);
  }

  function unlock() {
    locked = false;
    if (unlockTimer) {
      window.clearTimeout(unlockTimer);
      unlockTimer = 0;
    }
  }

  function onScroll() {
    if (locked) {
      window.clearTimeout(unlockTimer);
      unlockTimer = window.setTimeout(unlock, 150);
      return;
    }
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function() {
      ticking = false;
      if (!locked) syncActive();
    });
  }

  for (var i = 0; i < links.length; i++) {
    links[i].addEventListener('click', function(event) {
      var id = this.getAttribute('href').slice(1);
      var target = document.getElementById(id);
      if (!target) return;
      event.preventDefault();
      var hash = '#' + id;
      setActive(hash);
      locked = true;
      window.clearTimeout(unlockTimer);
      window.scrollTo({
        top: Math.max(0, window.pageYOffset + target.getBoundingClientRect().top - offset),
        behavior: 'smooth'
      });
      if (history.replaceState) history.replaceState(null, '', hash);
    });
  }

  measureOffset();
  syncActive();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('scrollend', unlock);
  window.addEventListener('resize', measureOffset);

  if (header) {
    var headerClasses = new MutationObserver(function() {
      window.setTimeout(measureOffset, 120);
    });
    headerClasses.observe(header, { attributes: true, attributeFilter: ['class'] });
  }
})();
